import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import { FDDialog, FDDialogContent, FDDialogTitle } from '@facet-wealth/design';
import ActionItemsHeader from './ActionItemsHeader';
import ActionItemList from '../../ActionItemList';

const useStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  content: {
    backgroundColor: theme.palette.facet.lightGray,
  },
  wrapper: {
    maxWidth: theme.dimensions.xxl,
    margin: 'auto',
  },
}));

export default function ActionItemsListDialog({
  open,
  handleClose,
  taskCollection,
  showHidden,
  replaceTaskResource,
  getTaskCollection,
  refreshDialogTaskCollection,
}) {
  const classes = useStyles();

  useComponentDidMount(() => {
    if (open) {
      getTaskCollection(showHidden);
    }
  });

  return (
    <FDDialog
      fullScreen
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <FDDialogTitle value={'My Actions'} />
      <FDDialogContent className={classes.content}>
        <div className={classes.wrapper}>
          <ActionItemsHeader
            showHidden={showHidden}
            getTaskCollection={getTaskCollection}
          />
          <ActionItemList
            actionItemCollection={taskCollection}
            refreshActionItems={refreshDialogTaskCollection}
            replaceActionItem={replaceTaskResource}
            background="white"
          />
        </div>
      </FDDialogContent>
    </FDDialog>
  );
}

ActionItemsListDialog.defaultProps = {
  taskCollection: null,
};

ActionItemsListDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  showHidden: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  taskCollection: PropTypes.object,
  replaceTaskResource: PropTypes.func.isRequired,
  getTaskCollection: PropTypes.func.isRequired,
  refreshDialogTaskCollection: PropTypes.func.isRequired,
};
